import {RouteType} from "core/router/Routes";
import {Currency} from "platform/enum/Currency";
import {SymbolSignal} from "platform/protocol/trading/SymbolSignal";
import {EduTradingCryptoCalendarEvent} from "protocol/edutrading/EduTradingCryptoCalendarEventsResponse";
import {CurrencyStrengthMeter} from "protocol/edutrading/EduTradingCurrencyStrengthMeterResponse";
import {EduTradingEconomicCalendarEvent} from "protocol/edutrading/EduTradingEconomicCalendarEventsResponse";
import {TrendAnalysisItem} from "protocol/edutrading/EduTradingTrendAnalysisResponse";
import {TSMap} from "typescript-map";

export interface MarketScannerItem {

    currencyCode: string;
    action: string;
    datetimeGmt: string;
    timeframe: string;
    price: number;
    strength: string;
    score: number;
}

export type LockedData = CurrencyStrengthMeter | TrendAnalysisItem | MarketScannerItem | EduTradingEconomicCalendarEvent | EduTradingCryptoCalendarEvent | SymbolSignal;

const LockedDataConfig = (): TSMap<RouteType, LockedData[]> => {
    const Config: TSMap<RouteType, any[]> = new TSMap<RouteType, any[]>();
    Config.set(RouteType.CurrencyStrengthMeter, currencyStrengthData);
    Config.set(RouteType.TrendAnalysis, trendAnalysisData);
    Config.set(RouteType.MarketScanners, marketScannerData);
    Config.set(RouteType.EconomicCalendar, economicCalendarEvents);
    Config.set(RouteType.CryptocurrencyCalendar, cryptoCalendarEvents);
    return Config;
};

const cryptoCalendarEvents: EduTradingCryptoCalendarEvent[] = [
    {
        name: "Release: Wallet Launch",
        currencyCode: "ZEC",
        currencyLogoUrl: "https://files.traducationfx.com/images/crypto-calendar/logos/64/ZEC.png",
        currencyName: "Zcash",
        dateEnd: "2025-04",
        dateStart: "2025-04",
        id: 1,
        impact: "medium",
        isInPast: false,
        sourceLink: "https://www.google.com",
    },
    {
        name: "Release: Wallet Launch",
        currencyCode: "ZEC",
        currencyLogoUrl: "https://files.traducationfx.com/images/crypto-calendar/logos/64/ZEC.png",
        currencyName: "Zcash",
        dateEnd: "2025-04",
        dateStart: "2025-04",
        id: 2,
        impact: "medium",
        isInPast: false,
        sourceLink: "https://www.google.com",
    },
    {
        name: "Release: Wallet Launch",
        currencyCode: "ZEC",
        currencyLogoUrl: "https://files.traducationfx.com/images/crypto-calendar/logos/64/ZEC.png",
        currencyName: "Zcash",
        dateEnd: "2025-04",
        dateStart: "2025-04",
        id: 3,
        impact: "medium",
        isInPast: false,
        sourceLink: "https://www.google.com",
    },
    {
        name: "Release: Wallet Launch",
        currencyCode: "ZEC",
        currencyLogoUrl: "https://files.traducationfx.com/images/crypto-calendar/logos/64/ZEC.png",
        currencyName: "Zcash",
        dateEnd: "2025-04",
        dateStart: "2025-04",
        id: 4,
        impact: "medium",
        isInPast: false,
        sourceLink: "https://www.google.com",
    },
    {
        name: "Release: Wallet Launch",
        currencyCode: "ZEC",
        currencyLogoUrl: "https://files.traducationfx.com/images/crypto-calendar/logos/64/ZEC.png",
        currencyName: "Zcash",
        dateEnd: "2025-04",
        dateStart: "2025-04",
        id: 5,
        impact: "medium",
        isInPast: false,
        sourceLink: "https://www.google.com",
    },
    {
        name: "Release: Wallet Launch",
        currencyCode: "ZEC",
        currencyLogoUrl: "https://files.traducationfx.com/images/crypto-calendar/logos/64/ZEC.png",
        currencyName: "Zcash",
        dateEnd: "2025-04",
        dateStart: "2025-04",
        id: 6,
        impact: "medium",
        isInPast: false,
        sourceLink: "https://www.google.com",
    }
]

const economicCalendarEvents: EduTradingEconomicCalendarEvent[] = [
    {
        name: "FPC Meeting Minutes",
        currencyCode: Currency.EUR,
        dateGmt: "2025-04-08",
        timeGmt:  "",
        actualValue: "",
        forecastedValue: "",
        previousValue: "",
        impact: "low",
        significance: "It provides a comprehensive record of the most recent meeting",
        sourceLink: "https://www.google.com",
        sourceWebsite: "https://www.google.com",
        frequency: "Quarterly",
        usualEffect: "Test test",
        id: 1,
    },
    {
        name: "FPC Meeting Minutes",
        currencyCode: Currency.USD,
        dateGmt: "2025-04-08",
        timeGmt:  "",
        actualValue: "",
        forecastedValue: "",
        previousValue: "",
        impact: "low",
        significance: "It provides a comprehensive record of the most recent meeting",
        sourceLink: "https://www.google.com",
        sourceWebsite: "https://www.google.com",
        frequency: "Quarterly",
        usualEffect: "Test test",
        id: 2,
    },
    {
        name: "FPC Meeting Minutes",
        currencyCode: Currency.CHF,
        dateGmt: "2025-04-08",
        timeGmt:  "",
        actualValue: "",
        forecastedValue: "",
        previousValue: "",
        impact: "low",
        significance: "It provides a comprehensive record of the most recent meeting",
        sourceLink: "https://www.google.com",
        sourceWebsite: "https://www.google.com",
        frequency: "Quarterly",
        usualEffect: "Test test",
        id: 3,
    },
    {
        name: "FPC Meeting Minutes",
        currencyCode: Currency.AUD,
        dateGmt: "2025-04-08",
        timeGmt:  "",
        actualValue: "",
        forecastedValue: "",
        previousValue: "",
        impact: "low",
        significance: "It provides a comprehensive record of the most recent meeting",
        sourceLink: "https://www.google.com",
        sourceWebsite: "https://www.google.com",
        frequency: "Quarterly",
        usualEffect: "Test test",
        id: 4,
    },
    {
        name: "FPC Meeting Minutes",
        currencyCode: Currency.RON,
        dateGmt: "2025-04-08",
        timeGmt:  "",
        actualValue: "",
        forecastedValue: "",
        previousValue: "",
        impact: "low",
        significance: "It provides a comprehensive record of the most recent meeting",
        sourceLink: "https://www.google.com",
        sourceWebsite: "https://www.google.com",
        frequency: "Quarterly",
        usualEffect: "Test test",
        id: 5,
    },
];

const currencyStrengthData: CurrencyStrengthMeter[] = [
    {
        currencyCode: Currency.EUR,
        strengths: [
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "-0.25%",
                formattedStrength: "-0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "M15",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            }
        ]
    },
    {
        currencyCode: Currency.CAD,
        strengths: [
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "+0.25%",
                formattedStrength: "+0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "H1",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            }
        ]
    },
    {
        currencyCode: Currency.USD,
        strengths: [
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "+0.25%",
                formattedStrength: "+0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "M5",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            },
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "+0.25%",
                formattedStrength: "+0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "M15",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            }
        ]
    },
    {
        currencyCode: Currency.JPY,
        strengths: [
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "-0.25%",
                formattedStrength: "-0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "M15",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            }
        ]
    },
    {
        currencyCode: Currency.PKR,
        strengths: [
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "+0.25%",
                formattedStrength: "+0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "M15",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            },
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "-0.25%",
                formattedStrength: "-0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "H1",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            }
        ]
    },
    {
        currencyCode: Currency.CZK,
        strengths: [
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "+0.25%",
                formattedStrength: "+0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "M15",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            },
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "-0.25%",
                formattedStrength: "-0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "H1",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            },
            {
                datetimeGmt: new Date().toString(),
                formattedPreviousStrength: "+0.25%",
                formattedStrength: "+0.32%",
                previousStrength: 0.05,
                priceChanges: null,
                strength: 0.35,
                strengthChange: 0.26,
                timeframe: "M5",
                timeframeSeconds: 900,
                timestampGmt: 1743761700
            }
        ]
    }
];

const trendAnalysisData: TrendAnalysisItem[] = [
    {
        asset: "EUR/USD",
        market: "Forex",
        trends: [
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                neutralCount: 2,
                timeframe: "M5",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12,
                indicatorResults: [{
                    formattedIndicatorInputs: "Test_Test: 5",
                    indicatorInputs: {period: 14},
                    indicatorName: "TestCase1",
                    indicatorValue: 1,
                    trend: "Neutral",
                    trendId: 3
                },
                {
                    formattedIndicatorInputs: "Test_Test: 4",
                    indicatorInputs: {period: 11},
                    indicatorName: "TestCase2",
                    indicatorValue: 2,
                    trend: "Neutral",
                    trendId: 3
                }
            ]
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M15",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "H1",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            }
            
        ]
    },
    {
        asset: "EUR/JPY",
        market: "Forex",
        trends: [
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M5",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Downtrend",
                trendId: 3,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M15",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "H1",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            }
            
        ]
    },
    {
        asset: "USD/JPY",
        market: "Forex",
        trends: [
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M5",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M15",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "H1",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            }
            
        ]
    },
    {
        asset: "USD/CAD",
        market: "Forex",
        trends: [
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M5",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M15",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "H1",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Downtrend",
                trendId: 3,
                uptrendCount: 12
            }
            
        ]
    },
    {
        asset: "JPY/CAD",
        market: "Forex",
        trends: [
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M5",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M15",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "H1",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Downtrend",
                trendId: 3,
                uptrendCount: 12
            }
            
        ]
    },
    {
        asset: "CAD/USD",
        market: "Forex",
        trends: [
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M5",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Downtrend",
                trendId: 3,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "M15",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            },
            {
                assetPrice: 1.12,
                assetPriceChange: 0.6,
                datetimeGmt: new Date().toString(),
                downtrendCount: 2,
                indicatorResults: [],
                neutralCount: 2,
                timeframe: "H1",
                timeframeSeconds: 300,
                timestampGmt: 1743764700,
                trend: "Uptrend",
                trendId: 4,
                uptrendCount: 12
            }
            
        ]
    },
]

const marketScannerData: MarketScannerItem[] = [
    {
        currencyCode: Currency.EUR,
        action: "BUY",
        datetimeGmt: new Date().toString(),
        timeframe: "M5",
        price: 1.09,
        strength: "low",
        score: 2,
    },
    {
        currencyCode: Currency.USD,
        action: "BUY",
        datetimeGmt: new Date().toString(),
        timeframe: "M5",
        price: 1.09,
        strength: "low",
        score: 2,
    },
    {
        currencyCode: Currency.AUD,
        action: "BUY",
        datetimeGmt: new Date().toString(),
        timeframe: "M5",
        price: 1.09,
        strength: "low",
        score: 2,
    },
    {
        currencyCode: Currency.JPY,
        action: "BUY",
        datetimeGmt: new Date().toString(),
        timeframe: "M5",
        price: 1.09,
        strength: "low",
        score: 2,
    }
]

export {
    LockedDataConfig
};
